import React from 'react';
import { motion } from 'framer-motion';
import { User } from 'lucide-react';
const testimonials = [{
  quote: 'Коли всі казали, що нічого не вдасться зробити, ці адвокати змогли оскаржити рішення ТЦК. Професіонали своєї справи.',
  author: 'Андрій М.',
  role: 'Військовослужбовець'
}, {
  quote: 'Дякую за швидку реакцію та якісну роботу. Вдалося отримати відстрочку завдяки їхній допомозі та знанню законодавства.',
  author: 'Олександр К.',
  role: 'Призовник'
}, {
  quote: 'Звернувся щодо незаконного висновку ВЛК. Адвокати оперативно втрутилися, допомогли зібрати медичні документи та успішно оскаржили рішення.',
  author: 'Віталій С.',
  role: 'Клієнт'
}];
export function Testimonials() {
  return <section id="testimonials" className="py-24 bg-surface" data-id="element-165">
      <div className="max-w-7xl mx-auto px-6" data-id="element-166">
        <div className="text-center mb-16" data-id="element-167">
          <h2 className="text-3xl md:text-4xl font-semibold mb-4" data-id="element-168">
            Відгуки клієнтів
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-7xl mx-auto" data-id="element-169">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-background p-8 rounded-3xl border border-border flex flex-col" data-id="element-170">
              <p className="text-lg text-primary leading-relaxed mb-8 flex-grow" data-id="element-171">
                "{item.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-172">
                <div className="w-10 h-10 rounded-full bg-surface flex items-center justify-center text-secondary" data-id="element-173">
                  <User size={18} data-id="element-174" />
                </div>
                <div data-id="element-175">
                  <div className="font-medium text-sm text-primary" data-id="element-176">
                    {item.author}
                  </div>
                  <div className="text-xs text-secondary" data-id="element-177">{item.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}